export default "__VITE_ASSET__DYztpCqe__"